// Build-time feature flags, read from .env. Each repo's main-build branch keeps its own .env,
// so a flag set only in the dev repo's main-build .env stays off on production.

// "true" shows the unfinished quotation version features (Compare button, Versions tab) on the Quotation Preview.
export const FLAG_QUOTATION_VERSIONS = process.env.REACT_APP_FLAG_QUOTATION_VERSIONS === "true"
